"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.assign.js");

require("antd/lib/tooltip/style");

var _tooltip = _interopRequireDefault(require("antd/lib/tooltip"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("@ant-design/icons");

var _excluded = ["info"];
var _default = InfoIcon;
/**
 * @desc InfoIcon component
 * @param info
 * @returns {*}
 * @constructor
 */

exports.default = _default;

function InfoIcon(_ref) {
  var info = _ref.info,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_tooltip.default, Object.assign({
    title: info,
    placement: "top"
  }, rest), /*#__PURE__*/_react.default.createElement(_icons.InfoCircleOutlined, null));
}